var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 828,
    viewBox: "0 0 673 828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-278.915 528.727L249.051 0.760825L476.942 228.652C516.127 267.837 542.68 309.858 556.601 354.714C570.522 399.571 571.64 444.17 559.953 488.511C548.266 532.851 523.689 573.755 486.223 611.221C448.413 649.031 407.252 673.35 362.739 684.178C318.398 695.177 273.628 693.029 228.427 677.733C183.399 662.609 140.777 634.939 100.561 594.722L-35.5556 458.606L75.8122 347.238L183.055 454.481C199.898 471.324 217.17 482.753 234.872 488.768C252.918 494.784 270.62 495.471 287.978 490.831C305.508 486.362 321.749 476.652 336.702 461.7C351.826 446.576 361.45 430.421 365.575 413.234C370.043 396.048 369.098 378.604 362.739 360.902C356.724 343.2 345.295 325.927 328.452 309.085L277.924 258.557L-135.58 672.061L-278.915 528.727Z",
    fill: "white",
    fillOpacity: 0.11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/p.8028a207f1f23409ea31afaf3d418b5e.svg";
export { ForwardRef as ReactComponent };